import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { WEBHOOK } from 'src/app/constants/endpoint.const';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { ModalAddWebhookComponent } from '../modal-add-webhook/modal-add-webhook.component';

@Component({
  standalone: false,
  selector: 'app-webhook-shipping',
  templateUrl: './webhook-shipping.component.html',
  styleUrls: ['./webhook-shipping.component.scss'],
})
export class WebhookShippingComponent implements OnInit {
  @Input() isGetWebhook: boolean = true;
  @Output() upgrade = new EventEmitter<void>();

  destroy$ = new Subject();
  listWebhook: string = '';
  loading: boolean = true;
  isEditMode: boolean = false;

  formGroupWebhook: FormGroup = new FormGroup({
    url: new FormControl('', []),
  });
  isValidURL: boolean = true;
  errPN: string = '';
  isSame: boolean = true;

  constructor(
    private message: NzMessageService,
    private modalService: NgbModal,
    private baseService: BaseService,
    private validationService: FormValidationService
  ) {}

  get isSaveDisabled(): boolean {
    return (
      this.errPN !== '' ||
      this.formGroupWebhook.invalid ||
      this.isSame ||
      !this.formGroupWebhook.get('url')?.value
    );
  }

  ngOnInit(): void {
    this.getWebhook();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  setValueRuleWebhook() {
    const value = this.formGroupWebhook.get('url')?.value || '';
    const result = this.validationService.validateUrl(value);
    this.isValidURL = result.valid;
    this.errPN = result.message;

    if (value === this.listWebhook) {
      this.formGroupWebhook.get('url')?.setErrors({ notUnique: true });
      this.isSame = true;
    } else {
      this.isSame = false;
    }
  }

  toggleEdit() {
    this.isEditMode = true;
    this.formGroupWebhook.get('url')?.enable();
  }

  submit() {
    const params = {
      webhook_url: this.formGroupWebhook.get('url')?.value,
    };
    this.baseService
      .putData(WEBHOOK, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.message.create(
            'success',
            'Your webhook url has been successfully saved.'
          );
          this.getWebhook();
          this.isSame = true;
        },
        (err) => {
          this.message.create('error', err.error.meta.message);
        }
      );
  }

  addWebhook() {
    const modal = this.modalService.open(ModalAddWebhookComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
    });

    const modalInstance = modal.componentInstance as ModalAddWebhookComponent;

    modalInstance.updateWebhook.subscribe(() => {
      this.getWebhook();
    });
  }

  getWebhook() {
    this.baseService
      .getData(WEBHOOK)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.listWebhook = res.data?.webhook_url || '';
          this.formGroupWebhook.get('url')?.setValue(this.listWebhook);
          if (this.listWebhook) {
            this.formGroupWebhook.get('url')?.disable();
            this.isEditMode = false;
          } else {
            this.formGroupWebhook.get('url')?.enable();
            this.isEditMode = true;
          }
        },
        (err) => {
          this.message.create('error', 'Failed to get Webhook data');
          console.warn(err);
        }
      );
  }

  upgradeToEnterprise() {
    this.upgrade.emit();
  }
}
